
export const dimsdata = {
  "H1.00.01": {
    "Bedroom 1": "2.80m x 4.90m",
    "Bedroom 2": "3.25m x 3.60m",
    Kitchen: "3.65m x 2.60m",
    "Living / Dining": "5.20m x 4.15m",
    Terrace: "11.25m x 2.55m",
    "Total internal area": "78.0 sq m",
    "Total external area": "27.0 sq m"
  },
  "H1.01.01": {
    "Balcony 1": "1.50m x 2.45m",
    "Balcony 2": "1.50m x 2.45m",
    "Bedroom 1": "3.55m x 3.50m",
    "Bedroom 2": "3.25m x 4.20m",
    Kitchen: "1.90m x 4.50m",
    "Living / Dining": "3.65m x 4.80m",
    "Total internal area": "75.0 sq m",
    "Total external area": "8.0 sq m"
  },
  "H1.01.02": {
    Balcony: "3.05m x 1.90m",
    "Bedroom 1": "2.85m x 4.70m",
    "Bedroom 2": "3.50m x 3.00m",
    Kitchen: "3.50m x 1.95m",
    "Living / Dining": "3.50m x 5.00m",
    "Total internal area": "72.0 sq m",
    "Total external area": "6.0 sq m"
  },
  "H1.01.03": {
    Balcony: "3.05m x 1.90m",
    "Bedroom 1": "3.70m x 5.10m",
    "Bedroom 2": "2.75m x 4.65m",
    Kitchen: "2.85m x 2.30m",
    "Living / Dining": "4.10m x 5.05m",
    "Total internal area": "79.0 sq m",
    "Total external area": "6.0 sq m"
  },
  "H1.02.01": {
    Balcony: "1.55m x 3.50m",
    "Bedroom 1": "5.65m x 3.30m",
    "Bedroom 2": "4.40m x 3.15m",
    Kitchen: "3.65m x 3.25m",
    "Living / Dining": "5.05m x 4.45m",
    "Total internal area": "89.0 sq m",
    "Total external area": "4.5 sq m"
  },
  "H1.02.02": {
    "Balcony 1": "1.75m x 2.25m",
    "Balcony 2": "0.90m x 2.25m",
    "Bedroom 1": "3.70m x 6.30m",
    "Bedroom 2": "3.75m x 3.30m",
    Kitchen: "1.90m x 6.30m",
    "Living / Dining": "3.85m x 7.10m",
    "Total internal area": "89.0 sq m",
    "Total external area": "6.0 sq m"
  },
  "H1.02.03": {
    Balcony: "3.05m x 1.90m",
    "Bedroom 1": "2.80m x 5.50m",
    "Bedroom 2": "3.15m x 3.90m",
    Kitchen: "2.55m x 3.05m",
    "Living / Dining": "5.05m x 3.90m",
    "Total internal area": "78.0 sq m",
    "Total external area": "6.0 sq m"
  },
  "H1.02.04": {
    "Balcony 1": "3.05m x 1.90m",
    "Balcony 2": "2.25m x 0.90m",
    "Bedroom 1": "2.90m x 5.10m",
    "Bedroom 2": "3.95m x 2.80m",
    Kitchen: "2.90m x 2.05m",
    "Living / Dining": "4.50m x 5.20m",
    "Total internal area": "80.0 sq m",
    "Total external area": "8.0 sq m"
  },
  "H1.03.01": {
    Balcony: "1.55m x 3.50m",
    "Bedroom 1": "5.65m x 3.30m",
    "Bedroom 2": "4.40m x 3.15m",
    Kitchen: "3.65m x 3.25m",
    "Living / Dining": "5.05m x 4.45m",
    "Total internal area": "89.0 sq m",
    "Total external area": "4.5 sq m"
  },
  "H1.03.02": {
    "Balcony 1": "1.75m x 2.25m",
    "Balcony 2": "0.90m x 2.25m",
    "Bedroom 1": "3.70m x 6.35m",
    "Bedroom 2": "3.75m x 3.30m",
    Kitchen: "0.85m x 6.35m",
    "Living / Dining": "4.90m x 7.10m",
    "Total internal area": "89.0 sq m",
    "Total external area": "6.0 sq m"
  },
  "H1.03.03": {
    Balcony: "3.05m x 1.90m",
    "Bedroom 1": "2.80m x 5.50m",
    "Bedroom 2": "3.15m x 3.90m",
    Kitchen: "2.55m x 3.05m",
    "Living / Dining": "5.05m x 3.90m",
    "Total internal area": "78.0 sq m",
    "Total external area": "6.0 sq m"
  },
  "H1.03.04": {
    "Balcony 1": "3.05m x 1.90m",
    "Balcony 2": "2.25m x 0.90m",
    "Bedroom 1": "3.35m x 5.10m",
    "Bedroom 2": "3.95m x 2.80m",
    Kitchen: "2.90m x 2.05m",
    "Living / Dining": "4.50m x 5.25m",
    "Total internal area": "80.0 sq m",
    "Total external area": "8.0 sq m"
  },
  "H1.04.01": {
    Balcony: "1.55m x 3.50m",
    "Bedroom 1": "5.55m x 3.30m",
    "Bedroom 2": "4.40m x 3.15m",
    Kitchen: "3.65m x 3.25m",
    "Living / Dining": "5.05m x 4.45m",
    "Total internal area": "89.0 sq m",
    "Total external area": "4.5 sq m"
  },
  "H1.04.02": {
    "Balcony 1": "1.75m x 2.25m",
    "Balcony 2": "0.90m x 2.25m",
    "Bedroom 1": "3.70m x 6.35m",
    "Bedroom 2": "3.75m x 3.30m",
    Kitchen: "1.90m x 6.35m",
    "Living / Dining": "3.85m x 7.15m",
    "Total internal area": "89.0 sq m",
    "Total external area": "6.0 sq m"
  },
  "H1.04.03": {
    Balcony: "3.05m x 1.90m",
    "Bedroom 1": "2.80m x 5.50m",
    "Bedroom 2": "3.15m x 3.90m",
    Kitchen: "2.55m x 3.05m",
    "Living / Dining": "5.05m x 3.90m",
    "Total internal area": "78.0 sq m",
    "Total external area": "6.0 sq m"
  },
  "H1.04.04": {
    "Balcony 1": "3.05m x 1.90m",
    "Balcony 2": "2.25m x 0.90m",
    "Bedroom 1": "3.35m x 5.10m",
    "Bedroom 2": "3.95m x 2.80m",
    Kitchen: "2.90m x 2.05m",
    "Living / Dining": "4.50m x 5.20m",
    "Total internal area": "80.0 sq m",
    "Total external area": "8.0 sq m"
  },
  "H1.05.01": {
    Balcony: "1.55m x 3.50m",
    "Bedroom 1": "5.55m x 3.30m",
    "Bedroom 2": "4.40m x 3.15m",
    Kitchen: "3.65m x 3.25m",
    "Living / Dining": "5.05m x 4.45m",
    "Total internal area": "89.0 sq m",
    "Total external area": "4.5 sq m"
  },
  "H1.05.02": {
    "Balcony 1": "1.75m x 2.25m",
    "Balcony 2": "0.90m x 2.25m",
    "Bedroom 1": "3.70m x 6.30m",
    "Bedroom 2": "3.75m x 3.30m",
    Kitchen: "1.90m x 6.30m",
    "Living / Dining": "3.85m x 7.10m",
    "Total internal area": "89.0 sq m",
    "Total external area": "6.0 sq m"
  },
  "H1.05.03": {
    Balcony: "3.05m x 1.90m",
    "Bedroom 1": "2.80m x 5.50m",
    "Bedroom 2": "3.15m x 3.90m",
    Kitchen: "2.55m x 3.05m",
    "Living / Dining": "5.05m x 3.90m",
    "Total internal area": "78.0 sq m",
    "Total external area": "6.0 sq m"
  },
  "H1.05.04": {
    "Balcony 1": "3.05m x 1.90m",
    "Balcony 2": "2.25m x 0.90m",
    "Bedroom 1": "3.35m x 5.10m",
    "Bedroom 2": "3.95m x 2.80m",
    Kitchen: "2.90m x 2.05m",
    "Living / Dining": "4.50m x 5.20m",
    "Total internal area": "80.0 sq m",
    "Total external area": "7.0 sq m"
  },
  "H1.06.01": {
    Balcony: "1.55m x 3.50m",
    "Bedroom 1": "5.65m x 3.30m",
    "Bedroom 2": "4.40m x 3.15m",
    Kitchen: "3.65m x 3.25m",
    "Living / Dining": "5.05m x 4.45m",
    "Total internal area": "89.0 sq m",
    "Total external area": "4.5 sq m"
  },
  "H1.06.02": {
    "Bedroom 1": "3.80m x 3.70m",
    "Bedroom 2": "3.15m x 4.85m",
    Kitchen: "3.85m x 2.50m",
    "Living / Dining": "8.95m x 3.95m",
    Terrace: "11.65m x 4.70m",
    "Total internal area": "93.0 sq m",
    "Total external area": "55.0 sq m"
  },
  "H1.06.03": {
    Balcony: "3.05m x 1.90m",
    Bedroom: "3.25m x 3.85m",
    Kitchen: "2.80m x 3.05m",
    "Living / Dining": "4.95m x 3.85m",
    "Total internal area": "58.0 sq m",
    "Total external area": "6.0 sq m"
  },
  "H1.06.04": {
    "Balcony 1": "3.05m x 1.90m",
    "Balcony 2": "2.25m x 0.90m",
    "Bedroom 1": "2.90m x 5.10m",
    "Bedroom 2": "3.95m x 2.80m",
    Kitchen: "2.90m x 2.05m",
    "Living / Dining": "4.50m x 5.20m",
    "Total internal area": "80.0 sq m",
    "Total external area": "8.0 sq m"
  },
  "H3.00.01": {
    "Bedroom 1": "7.00m x 3.30m",
    "Bedroom 2": "3.65m x 3.90m",
    Kitchen: "3.00m x 2.95m",
    "Living / Dining": "4.00m x 4.20m",
    Terrace: "2.10m x 8.10m",
    "Total internal area": "84.0 sq m",
    "Total external area": "17.0 sq m"
  },
  "H3.00.02": {
    Bedroom: "4.75m x 3.30m",
    Kitchen: "3.45m x 2.40m",
    "Living / Dining": "4.15m x 5.35m",
    Terrace: "2.10m x 8.10m",
    "Total internal area": "59.0 sq m",
    "Total external area": "17.0 sq m"
  },
  "H3.01.01": {
    Balcony: "1.90m x 3.55m",
    Bedroom: "3.65m x 3.90m",
    Kitchen: "3.20m x 2.05m",
    "Living / Dining": "4.00m x 3.95m",
    "Total internal area": "56.0 sq m",
    "Total external area": "7.0 sq m"
  },
  "H3.01.02": {
    Balcony: "1.90m x 3.05m",
    Bedroom: "4.50m x 2.85m",
    Kitchen: "2.50m x 2.65m",
    "Living / Dining": "4.50m x 3.90m",
    "Total internal area": "51.0 sq m",
    "Total external area": "6.0 sq m"
  },
  "H3.01.03": {
    Balcony: "1.90m x 3.05m",
    "Bedroom 1": "7.20m x 2.70m",
    "Bedroom 2": "3.35m x 4.45m",
    Kitchen: "2.45m x 2.20m",
    "Living / Dining": "4.75m x 4.25m",
    "Total internal area": "85.0 sq m",
    "Total external area": "6.0 sq m"
  },
  "H3.02.01": {
    "Balcony 1": "1.85m x 3.05m",
    "Balcony 2": "0.90m x 2.25m",
    "Bedroom 1": "4.40m x 3.45m",
    "Bedroom 2": "3.30m x 3.30m",
    Kitchen: "3.10m x 2.95m",
    "Living / Dining": "7.15m x 4.30m",
    "Total internal area": "80.0 sq m",
    "Total external area": "8.0 sq m"
  },
  "H3.02.02": {
    Balcony: "1.85m x 3.55m",
    "Bedroom 1": "5.35m x 3.00m",
    "Bedroom 2": "3.75m x 3.25m",
    Kitchen: "2.25m x 3.20m",
    "Living / Dining": "4.75m x 5.50m",
    "Total internal area": "83.0 sq m",
    "Total external area": "6.5 sq m"
  },
  "H3.02.03": {
    "Balcony 1": "1.85m x 3.05m",
    "Balcony 2": "0.90m x 2.25m",
    "Bedroom 1": "4.50m x 3.55m",
    "Bedroom 2": "3.45m x 3.30m",
    Kitchen: "2.50m x 2.95m",
    "Living / Dining": "4.50m x 4.25m",
    "Total internal area": "80.0 sq m",
    "Total external area": "6.0 sq m"
  },
  "H3.03.01": {
    "Balcony 1": "1.90m x 3.05m",
    "Balcony 2": "0.90m x 2.25m",
    "Bedroom 1": "4.40m x 3.45m",
    "Bedroom 2": "3.30m x 3.30m",
    Kitchen: "3.20m x 2.95m",
    "Living / Dining": "3.90m x 4.30m",
    "Total internal area": "80.0 sq m",
    "Total external area": "8.0 sq m"
  },
  "H3.03.02": {
    Balcony: "1.90m x 3.50m",
    "Bedroom 1": "5.40m x 3.00m",
    "Bedroom 2": "3.75m x 3.25m",
    Kitchen: "2.20m x 3.25m",
    "Living / Dining": "4.80m x 5.55m",
    "Total internal area": "83.0 sq m",
    "Total external area": "7.0 sq m"
  },
  "H3.03.03": {
    "Balcony 1": "1.90m x 3.05m",
    "Balcony 2": "0.90m x 2.25m",
    "Bedroom 1": "4.50m x 3.55m",
    "Bedroom 2": "3.45m x 3.30m",
    Kitchen: "2.50m x 2.95m",
    "Living / Dining": "4.50m x 4.20m",
    "Total internal area": "80.0 sq m",
    "Total external area": "8.0 sq m"
  },
  "H3.04.01": {
    "Balcony 1": "2.10m x 3.05m",
    "Balcony 2": "0.90m x 2.25m",
    "Bedroom 1": "4.40m x 3.45m",
    "Bedroom 2": "3.30m x 3.30m",
    Kitchen: "3.20m x 2.95m",
    "Living / Dining": "7.15m x 4.35m",
    "Total internal area": "80.0 sq m",
    "Total external area": "8.0 sq m"
  },
  "H3.04.02": {
    Balcony: "1.90m x 3.50m",
    "Bedroom 1": "5.40m x 3.00m",
    "Bedroom 2": "3.75m x 3.25m",
    Kitchen: "2.20m x 3.20m",
    "Living / Dining": "4.80m x 5.50m",
    "Total internal area": "83.0 sq m",
    "Total external area": "7.0 sq m"
  },
  "H3.04.03": {
    "Balcony 1": "2.10m x 3.05m",
    "Balcony 2": "0.90m x 2.25m",
    "Bedroom 1": "4.50m x 3.55m",
    "Bedroom 2": "3.45m x 3.30m",
    Kitchen: "2.50m x 2.95m",
    "Living / Dining": "4.50m x 4.25m",
    "Total internal area": "80.0 sq m",
    "Total external area": "8.0 sq m"
  },
  "H3.05.01": {
    "Balcony 1": "2.10m x 3.05m",
    "Balcony 2": "0.90m x 2.25m",
    "Bedroom 1": "4.40m x 3.45m",
    "Bedroom 2": "3.30m x 3.30m",
    Kitchen: "3.20m x 2.95m",
    "Living / Dining": "3.90m x 4.30m",
    "Total internal area": "80.0 sq m",
    "Total external area": "8.0 sq m"
  },
  "H3.05.02": {
    Balcony: "1.90m x 3.50m",
    "Bedroom 1": "5.40m x 3.00m",
    "Bedroom 2": "3.75m x 3.25m",
    Kitchen: "2.20m x 3.25m",
    "Living / Dining": "4.80m x 5.50m",
    "Total internal area": "83.0 sq m",
    "Total external area": "7.0 sq m"
  },
  "H3.05.03": {
    "Balcony 1": "2.10m x 3.05m",
    "Balcony 2": "0.90m x 2.25m",
    "Bedroom 1": "4.50m x 3.55m",
    "Bedroom 2": "3.45m x 3.30m",
    Kitchen: "2.50m x 2.95m",
    "Living / Dining": "4.50m x 4.25m",
    "Total internal area": "80.0 sq m",
    "Total external area": "8.0 sq m"
  },
  "H3.06.01": {
    "Balcony 1": "1.90m x 3.05m",
    "Balcony 2": "0.90m x 2.25m",
    "Bedroom 1": "5.90m x 3.80m",
    "Bedroom 2": "4.70m x 3.60m",
    "Bedroom 3": "3.65m x 3.15m",
    Kitchen: "2.50m x 4.25m",
    "Living / Dining": "4.30m x 6.75m",
    "Total internal area": "125.0 sq m",
    "Total external area": "8.0 sq m"
  },
  "H3.06.02": {
    "Balcony 1": "1.90m x 4.35m",
    "Balcony 2": "0.90m x 2.25m",
    "Bedroom 1": "4.70m x 3.35m",
    "Bedroom 2": "4.70m x 3.75m",
    "Bedroom 3": "3.65m x 3.05m",
    Kitchen: "2.60m x 3.95m",
    "Living / Dining": "4.20m x 6.70m",
    "Total internal area": "121.0 sq m",
    "Total external area": "11.0 sq m"
  },
  "H3.07.01": {
    "Balcony 1": "2.10m x 3.05m",
    "Balcony 2": "1.70m x 3.60m",
    "Balcony 3": "0.90m x 2.25m",
    "Balcony 4": "0.90m x 2.25m",
    "Bedroom 1": "4.85m x 3.55m",
    "Bedroom 2": "6.00m x 3.00m",
    "Bedroom 3": "4.05m x 3.05m",
    "Bedroom 4": "4.60m x 3.65m",
    Kitchen: "4.00m x 2.90m",
    "Living / Dining": "5.75m x 8.30m",
    "Total internal area": "170.0 sq m",
    "Total external area": "16.0 sq m"
  },
  "H3.07.02": {
    "Balcony 1": "1.90m x 4.35m",
    "Balcony 2": "0.90m x 2.25m",
    "Bedroom 1": "6.15m x 3.85m",
    "Bedroom 2": "4.70m x 3.65m",
    "Bedroom 3": "3.65m x 3.20m",
    "Bedroom 4": "4.70m x 3.05m",
    Kitchen: "2.50m x 4.25m",
    "Living / Dining": "4.25m x 6.95m",
    "Total internal area": "149.0 sq m",
    "Total external area": "11.0 sq m"
  },
  "H4.00.01": {
    "Bedroom 1": "4.55m x 3.15m",
    "Bedroom 2": "3.70m x 2.85m",
    Kitchen: "2.15m x 3.00m",
    "Living / Dining": "4.85m x 4.25m",
    Terrace: "2.10m x 9.90m",
    "Total internal area": "73.0 sq m",
    "Total external area": "20.0 sq m"
  },
  "H4.00.02": {
    "Bedroom 1": "7.00m x 3.30m",
    "Bedroom 2": "3.65m x 3.90m",
    Kitchen: "3.00m x 2.95m",
    "Living / Dining": "4.00m x 4.20m",
    Terrace: "2.10m x 8.10m",
    "Total internal area": "84.0 sq m",
    "Total external area": "17.0 sq m"
  },
  "H4.01.01": {
    Balcony: "1.90m x 3.05m",
    "Bedroom 1": "7.25m x 2.75m",
    "Bedroom 2": "3.35m x 4.45m",
    Kitchen: "2.45m x 2.20m",
    "Living / Dining": "4.75m x 4.20m",
    "Total internal area": "85.0 sq m",
    "Total external area": "6.0 sq m"
  },
  "H4.01.02": {
    Balcony: "1.90m x 3.05m",
    Bedroom: "4.50m x 2.85m",
    Kitchen: "2.50m x 2.60m",
    "Living / Dining": "4.50m x 3.90m",
    "Total internal area": "51.0 sq m",
    "Total external area": "6.0 sq m"
  },
  "H4.01.03": {
    Balcony: "1.90m x 3.55m",
    Bedroom: "3.65m x 3.90m",
    Kitchen: "3.20m x 2.05m",
    "Living / Dining": "4.00m x 3.95m",
    "Total internal area": "56.0 sq m",
    "Total external area": "7.0 sq m"
  },
  "H4.02.01": {
    "Balcony 1": "1.85m x 3.05m",
    "Balcony 2": "0.90m x 2.25m",
    "Bedroom 1": "4.50m x 3.55m",
    "Bedroom 2": "3.45m x 3.30m",
    Kitchen: "2.50m x 2.95m",
    "Living / Dining": "4.50m x 4.25m",
    "Total internal area": "80.0 sq m",
    "Total external area": "8.0 sq m"
  },
  "H4.02.02": {
    Balcony: "1.85m x 3.50m",
    "Bedroom 1": "5.35m x 3.05m",
    "Bedroom 2": "3.75m x 3.25m",
    Kitchen: "2.25m x 3.20m",
    "Living / Dining": "4.75m x 5.50m",
    "Total internal area": "83.0 sq m",
    "Total external area": "7.0 sq m"
  },
  "H4.02.03": {
    "Balcony 1": "1.85m x 3.05m",
    "Balcony 2": "0.90m x 2.25m",
    "Bedroom 1": "4.40m x 3.45m",
    "Bedroom 2": "3.30m x 3.30m",
    Kitchen: "3.20m x 2.95m",
    "Living / Dining": "3.90m x 4.30m",
    "Total internal area": "80.0 sq m",
    "Total external area": "8.0 sq m"
  },
  "H4.03.01": {
    "Balcony 1": "1.90m x 3.05m",
    "Balcony 2": "0.90m x 2.25m",
    "Bedroom 1": "4.50m x 3.55m",
    "Bedroom 2": "3.10m x 3.30m",
    Kitchen: "2.50m x 2.95m",
    "Living / Dining": "4.50m x 4.20m",
    "Total internal area": "80.0 sq m",
    "Total external area": "8.0 sq m"
  },
  "H4.03.02": {
    Balcony: "1.90m x 3.50m",
    "Bedroom 1": "5.40m x 3.05m",
    "Bedroom 2": "3.75m x 3.25m",
    Kitchen: "2.20m x 3.25m",
    "Living / Dining": "4.80m x 5.50m",
    "Total internal area": "83.0 sq m",
    "Total external area": "7.0 sq m"
  },
  "H4.03.03": {
    "Balcony 1": "1.90m x 3.05m",
    "Balcony 2": "0.90m x 2.25m",
    "Bedroom 1": "4.40m x 3.45m",
    "Bedroom 2": "3.30m x 3.30m",
    Kitchen: "3.10m x 2.80m",
    "Living / Dining": "7.15m x 4.30m",
    "Total internal area": "80.0 sq m",
    "Total external area": "8.0 sq m"
  },
  "H4.04.01": {
    "Balcony 1": "2.10m x 3.05m",
    "Balcony 2": "0.90m x 2.25m",
    "Bedroom 1": "4.50m x 3.55m",
    "Bedroom 2": "3.45m x 3.30m",
    Kitchen: "2.50m x 2.95m",
    "Living / Dining": "4.50m x 4.25m",
    "Total internal area": "80.0 sq m",
    "Total external area": "7.0 sq m"
  },
  "H4.04.02": {
    Balcony: "1.90m x 3.50m",
    "Bedroom 1": "5.40m x 3.05m",
    "Bedroom 2": "3.75m x 3.25m",
    Kitchen: "2.20m x 3.20m",
    "Living / Dining": "4.80m x 5.50m",
    "Total internal area": "83.0 sq m",
    "Total external area": "7.0 sq m"
  },
  "H4.04.03": {
    "Balcony 1": "2.10m x 3.05m",
    "Balcony 2": "0.90m x 2.25m",
    "Bedroom 1": "4.40m x 3.45m",
    "Bedroom 2": "3.30m x 3.30m",
    Kitchen: "3.10m x 2.85m",
    "Living / Dining": "4.05m x 4.30m",
    "Total internal area": "80.0 sq m",
    "Total external area": "8.0 sq m"
  },
  "H4.05.01": {
    "Balcony 1": "2.10m x 3.05m",
    "Balcony 2": "0.90m x 2.25m",
    "Bedroom 1": "4.50m x 3.55m",
    "Bedroom 2": "3.45m x 3.30m",
    Kitchen: "2.50m x 2.95m",
    "Living / Dining": "4.50m x 4.25m",
    "Total internal area": "80.0 sq m",
    "Total external area": "8.0 sq m"
  },
  "H4.05.02": {
    Balcony: "1.90m x 3.50m",
    "Bedroom 1": "5.40m x 3.05m",
    "Bedroom 2": "3.75m x 3.25m",
    Kitchen: "2.20m x 3.20m",
    "Living / Dining": "4.80m x 5.50m",
    "Total internal area": "83.0 sq m",
    "Total external area": "7.0 sq m"
  },
  "H4.05.03": {
    "Balcony 1": "1.90m x 3.05m",
    "Balcony 2": "0.90m x 2.25m",
    "Bedroom 1": "4.40m x 3.45m",
    "Bedroom 2": "3.30m x 3.30m",
    Kitchen: "3.10m x 2.85m",
    "Living / Dining": "4.05m x 4.30m",
    "Total internal area": "80.0 sq m",
    "Total external area": "8.0 sq m"
  },
  "H4.06.01": {
    "Balcony 1": "1.90m x 4.35m",
    "Balcony 2": "0.90m x 2.25m",
    "Bedroom 1": "4.65m x 3.35m",
    "Bedroom 2": "4.70m x 3.80m",
    "Bedroom 3": "3.65m x 3.05m",
    Kitchen: "2.60m x 3.95m",
    "Living / Dining": "4.20m x 6.70m",
    "Total internal area": "121.0 sq m",
    "Total external area": "11.0 sq m"
  },
  "H4.06.02": {
    "Bedroom 1": "5.40m x 4.65m",
    "Bedroom 2": "5.40m x 3.95m",
    "Bedroom 3": "3.90m x 4.15m",
    "Bedroom 4": "3.90m x 4.15m",
    Kitchen: "4.90m x 3.70m",
    "Living / Dining": "6.30m x 7.10m",
    "Terrace Part 1": "8.45m x 4.70m",
    "Terrace Part 2": "14.25m x 6.85m",
    "Total internal area": "191.0 sq m",
    "Total external area": "121.0 sq m"
  },
  "H4.07.01": {
    "Balcony 1": "1.90m x 4.35m",
    "Balcony 2": "0.90m x 2.25m",
    "Bedroom 1": "4.65m x 3.80m",
    "Bedroom 2": "4.70m x 3.35m",
    "Bedroom 3": "3.60m x 3.05m",
    Kitchen: "2.60m x 3.95m",
    "Living / Dining": "4.25m x 6.70m",
    "Total internal area": "121.0 sq m",
    "Total external area": "11.0 sq m"
  },
  "H5.00.01": {
    "Bedroom 1": "3.40m x 3.35m",
    "Bedroom 2": "3.20m x 3.35m",
    Kitchen: "1.65m x 3.50m",
    "Living / Dining": "4.00m x 5.65m",
    "Winter Garden": "3.65m x 2.25m",
    "Total internal area": "62.0 sq m",
    "Total external area": "5.0 sq m"
  },
  "H5.00.02": {
    "Bedroom 1": "3.35m x 3.40m",
    "Bedroom 2": "3.35m x 3.15m",
    Kitchen: "3.50m x 1.65m",
    "Living / Dining": "5.65m x 4.00m",
    "Winter Garden": "2.25m x 3.65m",
    "Total internal area": "62.0 sq m",
    "Total external area": "5.0 sq m"
  },
  "H5.00.03": {
    Bedroom: "3.90m x 4.15m",
    Kitchen: "2.00m x 3.95m",
    "Living / Dining": "4.75m x 5.10m",
    Terrace: "6.75m x 2.45m",
    "Total internal area": "68.0 sq m",
    "Total external area": "15.0 sq m"
  },
  "H5.01.01": {
    Balcony: "2.25m x 1.80m",
    Bedroom: "3.40m x 3.35m",
    Kitchen: "3.20m x 3.00m",
    "Living / Dining": "3.20m x 3.70m",
    "Total internal area": "50.0 sq m",
    "Total external area": "4.0 sq m"
  },
  "H5.01.02": {
    "Winter Garden": "3.65m x 2.25m",
    Bedroom: "3.75m x 3.35m",
    Kitchen: "2.35m x 3.60m",
    "Living / Dining": "5.30m x 4.95m",
    "Total internal area": "56.0 sq m",
    "Total external area": "6.0 sq m"
  },
  "H5.01.03": {
    "Winter Garden": "2.25m x 3.65m",
    "Bedroom 1": "5.85m x 3.35m",
    "Bedroom 2": "3.60m x 4.30m",
    Kitchen: "3.40m x 2.20m",
    "Living / Dining": "5.65m x 6.25m",
    "Total internal area": "93.0 sq m",
    "Total external area": "6.0 sq m"
  },
  "H5.01.04": {
    Balcony: "2.65m x 2.25m",
    Bedroom: "4.85m x 3.90m",
    Kitchen: "3.65m x 3.45m",
    "Living / Dining": "3.20m x 4.90m",
    "Total internal area": "72.0 sq m",
    "Total external area": "3.0 sq m"
  },
  "H5.02.01": {
    "Balcony 1": "3.60m x 1.60m",
    "Balcony 2": "2.25m x 0.90m",
    "Bedroom 1": "3.30m x 2.95m",
    "Bedroom 2": "3.45m x 3.50m",
    Kitchen: "2.65m x 2.55m",
    "Living / Dining": "3.95m x 6.85m",
    "Total internal area": "86.0 sq m",
    "Total external area": "7.0 sq m"
  },
  "H5.02.02": {
    "Winter Garden": "2.80m x 5.50m",
    "Bedroom 1": "4.95m x 3.40m",
    "Bedroom 2": "3.95m x 3.35m",
    Kitchen: "2.80m x 3.75m",
    "Living / Dining": "4.75m x 5.65m",
    "Total internal area": "88.0 sq m",
    "Total external area": "12.0 sq m"
  },
  "H5.02.03": {
    "Balcony 1": "1.70m x 3.60m",
    "Balcony 2": "0.90m x 2.25m",
    "Bedroom 1": "4.10m x 3.25m",
    "Bedroom 2": "3.50m x 3.45m",
    Kitchen: "2.25m x 3.10m",
    "Living / Dining": "6.60m x 3.95m",
    "Total internal area": "88.0 sq m",
    "Total external area": "7.0 sq m"
  },
  "H5.02.04": {
    Balcony: "2.65m x 2.25m",
    Bedroom: "3.35m x 4.15m",
    Kitchen: "2.60m x 2.45m",
    "Living / Dining": "4.20m x 3.80m",
    "Total internal area": "53.0 sq m",
    "Total external area": "6.0 sq m"
  },
  "H5.03.01": {
    "Balcony 1": "3.60m x 1.70m",
    "Balcony 2": "2.25m x 0.90m",
    "Bedroom 1": "6.10m x 2.95m",
    "Bedroom 2": "3.45m x 4.20m",
    Kitchen: "2.70m x 2.50m",
    "Living / Dining": "4.00m x 6.90m",
    "Total internal area": "86.0 sq m",
    "Total external area": "7.0 sq m"
  },
  "H5.03.02": {
    "Winter Garden": "2.80m x 5.50m",
    "Bedroom 1": "4.95m x 3.40m",
    "Bedroom 2": "3.95m x 3.35m",
    Kitchen: "2.80m x 3.75m",
    "Living / Dining": "4.75m x 5.45m",
    "Total internal area": "88.0 sq m",
    "Total external area": "12.0 sq m"
  },
  "H5.03.03": {
    "Balcony 1": "1.70m x 3.60m",
    "Balcony 2": "0.90m x 2.25m",
    "Bedroom 1": "3.55m x 6.20m",
    "Bedroom 2": "3.50m x 3.45m",
    Kitchen: "2.25m x 3.15m",
    "Living / Dining": "6.60m x 3.95m",
    "Total internal area": "88.0 sq m",
    "Total external area": "7.0 sq m"
  },
  "H5.03.04": {
    Balcony: "2.65m x 2.25m",
    Bedroom: "3.35m x 4.15m",
    Kitchen: "2.60m x 2.45m",
    "Living / Dining": "4.20m x 3.80m",
    "Total internal area": "53.0 sq m",
    "Total external area": "6.0 sq m"
  },
  "H5.04.01": {
    "Winter Garden": "2.80m x 5.50m",
    "Bedroom 1": "3.15m x 3.30m",
    "Bedroom 2": "3.65m x 4.00m",
    "Bedroom 3": "4.75m x 3.20m",
    Kitchen: "3.60m x 3.55m",
    "Living / Dining": "5.05m x 5.65m",
    Terrace: "4.70m x 6.05m",
    "Total internal area": "127.0 sq m",
    "Total external area": "41.0 sq m"
  },
  "H5.04.02": {
    "Balcony 1": "1.70m x 3.60m",
    "Balcony 2": "0.90m x 2.25m",
    "Bedroom 1": "4.10m x 3.25m",
    "Bedroom 2": "3.50m x 3.50m",
    Kitchen: "2.25m x 3.10m",
    "Living / Dining": "6.60m x 4.00m",
    "Total internal area": "88.0 sq m",
    "Total external area": "7.0 sq m"
  },
  "H5.04.03": {
    "Balcony 1": "3.60m x 1.70m",
    "Balcony 2": "2.65m x 2.25m",
    Bedroom: "6.15m x 3.45m",
    Kitchen: "4.00m x 2.00m",
    "Living / Dining": "7.15m x 4.15m",
    "Total internal area": "75.0 sq m",
    "Total external area": "11.5 sq m"
  },
  "H5.05.01": {
    "Winter Garden": "2.80m x 5.50m",
    "Bedroom 1": "3.15m x 3.35m",
    "Bedroom 2": "3.65m x 4.00m",
    "Bedroom 3": "4.75m x 3.20m",
    Kitchen: "3.60m x 3.55m",
    "Living / Dining": "5.05m x 5.65m",
    "Total internal area": "127.0 sq m",
    "Total external area": "12.0 sq m"
  },
  "H5.05.02": {
    "Balcony 1": "1.70m x 3.60m",
    "Balcony 2": "0.90m x 2.25m",
    "Bedroom 1": "4.10m x 3.25m",
    "Bedroom 2": "3.50m x 3.45m",
    Kitchen: "2.25m x 3.10m",
    "Living / Dining": "6.60m x 4.00m",
    "Total internal area": "88.0 sq m",
    "Total external area": "7.0 sq m"
  },
  "H5.05.03": {
    "Balcony 1": "3.60m x 1.70m",
    "Balcony 2": "2.65m x 2.25m",
    Bedroom: "6.85m x 3.30m",
    Kitchen: "4.00m x 2.00m",
    "Living / Dining": "7.25m x 4.15m",
    "Total internal area": "75.0 sq m",
    "Total external area": "9.0 sq m"
  },
  "H6.01.01": {
    "Balcony 1": "1.50m x 2.45m",
    "Balcony 2": "1.50m x 2.45m",
    "Bedroom 1": "3.30m x 3.90m",
    "Bedroom 2": "2.75m x 3.95m",
    Kitchen: "2.00m x 2.65m",
    "Living / Dining": "4.05m x 4.20m",
    "Total internal area": "68.0 sq m",
    "Total external area": "8.0 sq m"
  },
  "H6.01.02": {
    Balcony: "1.80m x 3.40m",
    "Bedroom 1": "4.60m x 3.50m",
    "Bedroom 2": "3.35m x 3.30m",
    Kitchen: "2.00m x 4.60m",
    "Living / Dining": "5.20m x 3.55m",
    "Total internal area": "83.5 sq m",
    "Total external area": "7.0 sq m"
  },
  "H6.01.03": {
    "Balcony 1": "3.55m x 1.90m",
    "Balcony 2": "2.25m x 1.80m",
    "Bedroom 1": "3.70m x 5.00m",
    "Bedroom 2": "3.25m x 3.60m",
    Kitchen: "0.70m x 5.05m",
    Living: "2.25m x 4.40m",
    "Living / Dining": "2.70m x 6.75m",
    "Total internal area": "82.0 sq m",
    "Total external area": "11.0 sq m"
  },
  "H6.02.01": {
    "Balcony 1": "1.75m x 2.25m",
    "Balcony 2": "0.90m x 2.25m",
    "Bedroom 1": "3.95m x 6.95m",
    "Bedroom 2": "3.20m x 4.10m",
    Kitchen: "2.55m x 5.50m",
    "Living / Dining": "4.20m x 6.75m",
    "Total internal area": "89.0 sq m",
    "Total external area": "6.0 sq m"
  },
  "H6.02.02": {
    Balcony: "1.80m x 3.50m",
    "Bedroom 1": "4.60m x 3.50m",
    "Bedroom 2": "3.35m x 3.30m",
    Kitchen: "2.00m x 4.60m",
    "Living / Dining": "5.20m x 3.55m",
    "Total internal area": "83.5 sq m",
    "Total external area": "7.0 sq m"
  },
  "H6.02.03": {
    "Balcony 1": "4.40m x 1.90m",
    "Balcony 2": "2.25m x 0.90m",
    "Bedroom 1": "3.25m x 5.70m",
    "Bedroom 2": "3.15m x 7.20m",
    "Bedroom 3": "3.95m x 4.60m",
    Kitchen: "2.65m x 3.50m",
    "Living / Dining": "4.65m x 6.70m",
    "Total internal area": "124.0 sq m",
    "Total external area": "10.0 sq m"
  },
  "H6.03.01": {
    "Balcony 1": "1.75m x 2.25m",
    "Balcony 2": "0.90m x 2.25m",
    "Bedroom 1": "3.95m x 6.95m",
    "Bedroom 2": "3.20m x 4.10m",
    Kitchen: "2.55m x 5.50m",
    "Living / Dining": "4.20m x 6.75m",
    "Total internal area": "89.0 sq m",
    "Total external area": "6.0 sq m"
  },
  "H6.03.02": {
    Balcony: "1.80m x 3.50m",
    "Bedroom 1": "4.60m x 3.50m",
    "Bedroom 2": "3.35m x 3.30m",
    Kitchen: "2.00m x 4.60m",
    "Living / Dining": "5.20m x 3.55m",
    "Total internal area": "83.5 sq m",
    "Total external area": "7.0 sq m"
  },
  "H6.03.03": {
    "Balcony 1": "4.40m x 1.90m",
    "Balcony 2": "2.25m x 0.85m",
    "Bedroom 1": "3.25m x 5.70m",
    "Bedroom 2": "3.95m x 4.60m",
    "Bedroom 3": "3.10m x 7.20m",
    Kitchen: "2.60m x 3.50m",
    "Living / Dining": "4.70m x 6.70m",
    "Total internal area": "124.0 sq m",
    "Total external area": "10.0 sq m"
  },
  "H7.00.01": {
    "Bedroom 1": "3.35m x 4.20m",
    "Bedroom 2": "3.85m x 3.20m",
    "Bedroom 3": "3.85m x 3.90m",
    "Bedroom 4": "3.35m x 2.75m",
    Kitchen: "3.35m x 2.60m",
    "Living / Dining": "4.60m x 5.85m",
    Terrace: "1.45m x 16.00m",
    "Total internal area": "107.0 sq m",
    "Total external area": "23.0 sq m"
  },
  "H7.00.02": {
    "Bedroom 1": "3.45m x 4.30m",
    "Bedroom 2": "3.75m x 3.45m",
    "Bedroom 3": "3.75m x 3.95m",
    "Bedroom 4": "3.45m x 2.75m",
    Kitchen: "4.05m x 2.40m",
    "Living / Dining": "4.60m x 6.00m",
    Terrace: "1.45m x 16.00m",
    "Total internal area": "110.0 sq m",
    "Total external area": "23.0 sq m"
  },
  "H7.01.01": {
    "Balcony 1": "1.50m x 2.45m",
    "Balcony 2": "1.50m x 2.45m",
    "Balcony 3": "1.50m x 2.45m",
    Bedroom: "3.45m x 3.30m",
    Kitchen: "3.60m x 2.00m",
    "Living / Dining": "3.60m x 5.20m",
    "Total internal area": "51.0 sq m",
    "Total external area": "12.0 sq m"
  },
  "H7.01.02": {
    Balcony: "1.50m x 2.45m",
    Bedroom: "3.60m x 3.60m",
    Kitchen: "3.25m x 2.15m",
    "Living / Dining": "4.55m x 4.75m",
    "Total internal area": "54.0 sq m",
    "Total external area": "4.0 sq m"
  },
  "H7.01.03": {
    Balcony: "1.50m x 2.45m",
    Bedroom: "3.40m x 3.50m",
    Kitchen: "3.25m x 2.15m",
    "Living / Dining": "4.75m x 4.95m",
    "Total internal area": "54.0 sq m",
    "Total external area": "4.0 sq m"
  },
  "H7.01.04": {
    "Balcony 1": "1.50m x 2.40m",
    "Balcony 2": "1.50m x 2.45m",
    "Balcony 3": "1.50m x 2.45m",
    Bedroom: "3.20m x 3.20m",
    Kitchen: "4.20m x 2.00m",
    "Living / Dining": "4.15m x 5.05m",
    "Total internal area": "51.0 sq m",
    "Total external area": "12.0 sq m"
  },
  "H7.02.01": {
    Balcony: "1.75m x 2.25m",
    Bedroom: "3.30m x 3.20m",
    Kitchen: "2.60m x 2.35m",
    "Living / Dining": "3.60m x 6.70m",
    "Total internal area": "55.0 sq m",
    "Total external area": "4.0 sq m"
  },
  "H7.02.02": {
    "Balcony 1": "1.75m x 2.25m",
    "Balcony 2": "0.90m x 2.25m",
    "Bedroom 1": "3.05m x 6.55m",
    "Bedroom 2": "4.10m x 2.95m",
    Kitchen: "1.60m x 5.15m",
    "Living / Dining": "4.20m x 6.75m",
    "Total internal area": "85.0 sq m",
    "Total external area": "6.0 sq m"
  },
  "H7.02.03": {
    "Balcony 1": "1.75m x 2.25m",
    "Balcony 2": "0.90m x 2.25m",
    "Bedroom 1": "3.80m x 5.80m",
    "Bedroom 2": "3.30m x 3.40m",
    Kitchen: "1.90m x 5.45m",
    "Living / Dining": "3.10m x 6.40m",
    "Total internal area": "85.0 sq m",
    "Total external area": "6.0 sq m"
  },
  "H7.02.04": {
    Balcony: "1.75m x 2.25m",
    Bedroom: "3.05m x 3.85m",
    Kitchen: "3.80m x 2.35m",
    "Living / Dining": "4.25m x 7.10m",
    "Total internal area": "58.0 sq m",
    "Total external area": "4.0 sq m"
  },
  "H7.03.01": {
    Balcony: "1.75m x 2.25m",
    Bedroom: "3.30m x 3.20m",
    Kitchen: "2.60m x 2.35m",
    "Living / Dining": "3.60m x 6.75m",
    "Total internal area": "55.0 sq m",
    "Total external area": "4.0 sq m"
  },
  "H7.03.02": {
    "Balcony 1": "1.75m x 2.25m",
    "Balcony 2": "0.90m x 2.25m",
    "Bedroom 1": "3.05m x 6.55m",
    "Bedroom 2": "4.10m x 2.95m",
    Kitchen: "1.60m x 5.15m",
    "Living / Dining": "4.20m x 6.80m",
    "Total internal area": "85.0 sq m",
    "Total external area": "6.0 sq m"
  },
  "H7.03.03": {
    "Balcony 1": "1.75m x 2.25m",
    "Balcony 2": "0.90m x 2.25m",
    "Bedroom 1": "3.80m x 5.80m",
    "Bedroom 2": "3.00m x 3.40m",
    Kitchen: "1.90m x 5.45m",
    "Living / Dining": "3.10m x 6.40m",
    "Total internal area": "85.0 sq m",
    "Total external area": "6.0 sq m"
  },
  "H7.03.04": {
    Balcony: "1.75m x 2.25m",
    Bedroom: "3.05m x 3.85m",
    Kitchen: "3.80m x 2.30m",
    "Living / Dining": "4.25m x 7.10m",
    "Total internal area": "58.0 sq m",
    "Total external area": "4.0 sq m"
  },
  "H7.04.01": {
    Balcony: "1.75m x 2.25m",
    "Bedroom 1": "3.60m x 6.45m",
    "Bedroom 2": "2.95m x 5.25m",
    "Bedroom 3": "3.10m x 4.75m",
    Kitchen: "2.15m x 3.25m",
    "Living / Dining": "3.90m x 7.15m",
    Terrace: "11.60m x 4.70m",
    "Total internal area": "122.0 sq m",
    "Total external area": "60.0 sq m"
  },
  "H7.04.02": {
    "Balcony 1": "1.75m x 2.25m",
    "Balcony 2": "0.90m x 2.25m",
    "Bedroom 1": "3.80m x 5.80m",
    "Bedroom 2": "3.30m x 3.35m",
    Kitchen: "1.90m x 5.45m",
    "Living / Dining": "3.10m x 6.40m",
    "Total internal area": "85.0 sq m",
    "Total external area": "6.0 sq m"
  },
  "H7.04.03": {
    Balcony: "1.75m x 2.25m",
    Bedroom: "3.05m x 3.95m",
    Kitchen: "3.85m x 2.35m",
    "Living / Dining": "4.25m x 7.10m",
    "Total internal area": "58.0 sq m",
    "Total external area": "4.0 sq m"
  },
  "H7.05.01": {
    "Balcony 1": "1.75m x 2.25m",
    "Balcony 2": "0.90m x 2.25m",
    "Bedroom 1": "3.60m x 7.55m",
    "Bedroom 2": "4.35m x 3.00m",
    "Bedroom 3": "4.10m x 3.35m",
    Kitchen: "3.20m x 3.95m",
    "Living / Dining": "4.25m x 8.05m",
    Terrace: "7.45m x 4.70m",
    "Total internal area": "131.0 sq m",
    "Total external area": "41.0 sq m"
  }
}
